import React from 'react'

export const BungalowIcon = () => {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width='200px'
      height='200px'
      viewBox='0 0 2000 2000'
      xmlSpace='preserve'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#474747'
        d='M1251.893,928.087c141.072-141.056,43.973-387.112-145.739-387.112
	h-87.286v620.155l-210.396,210.396V540.975H598.079v918.051c140.267,0,280.519-0.108,420.789-0.357V1161.13L1251.893,928.087
	L1251.893,928.087z M1229.263,1459.025V954.239C1457.766,1042.452,1461.178,1369.504,1229.263,1459.025z'
      />
    </svg>
  )
}
